/* global theme */

import { pinForm, provinceOfResidenceField } from './global.js';

export var utils = {
  isContest: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.contest === 'true') {
      return true;
    }

    return false;
  },

  isDraw: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.draw === 'true') {
      return true;
    }

    return false;
  },

  isTestMode: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.testMode === 'true') {
      return true;
    }

    return false;
  },

  isPinBypassMode: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.pinBypass === 'true') {
      return true;
    }

    return false;
  },

  isUserSelection: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.userSelection === 'true') {
      return true;
    }

    return false;
  },

  hasHouseholdLimit: function () {
    if (!pinForm) {
      return false;
    }

    if (pinForm.dataset.hasHouseholdLimit === 'true') {
      return true;
    }

    return false;
  },

  getLegalAge: function () {
    var province = provinceOfResidenceField.value,
      youngProvinces = ['AB', 'MB', 'QC'];

    if (theme.jQuery.inArray(province, youngProvinces) !== -1) {
      return 18;
    }

    return 19;
  },

  isAgeValid: function (dateOfBirth) {
    var today = new Date();
    var birthDate = new Date(dateOfBirth);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < this.getLegalAge()) {
      return false;
    }

    return true;
  },

  getEligibleProvinces: function () {
    return pinForm.dataset.provinceNames;
  },

  removeArrayBlanks: function (array) {
    return array.filter(function (value) {
      return !!value;
    });
  },

  makeId: function (length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
};
